import React, { Children, useState } from 'react'

import './Tabs.scss';

function Tabs(props) {

    const { children, tabData } = props;

    const handleChange = (ev) => {
        document.querySelectorAll(".tab-item").forEach(el => el.classList.remove('selected'));
        document.getElementById(`tab_item${ev.target.value}`).classList.add('selected');
    }

    return (
        <section className='generic-tabs'>
            <div className='tab-navigators'>
                {
                    tabData?.map((td, idx) =>
                        <div>
                            <input type="radio" key={`g_tab_${idx}`} value={idx} id={`g_tab_${idx}`} name="selector" onChange={handleChange} />
                            <label key={`g_tab_lbl_${idx}`} htmlFor={`g_tab_${idx}`} className={`tab-label`}>{td.icon}{td.label}</label>
                        </div>
                    )
                }
            </div>
            <div className='tab-content'>
                {
                    Children.map(children, (ch, idx) =>
                        <div className='tab-item' id={`tab_item${idx}`} key={`tab_item${idx}`}>
                            {ch}
                        </div>)
                }
            </div>
        </section>
    );
}

export default Tabs;